import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetFinanceServicesFinancetypesRequestModel, GetFinanceServicesFinancetypesResponseModel } from "@/features/accounts/finance/services/get-services-financetypes-model";

export class GetFinanceServicesFinancetypesApi {
  /**
   * 銀行口座種別取得API
   */
  public getFinanceServicesFinancetypes = async (
    param: GetFinanceServicesFinancetypesRequestModel
  ): Promise<GetFinanceServicesFinancetypesResponseModel[]> => {
    const path = `/api/institutions/services/financetypes`;
    const res = await ApiClient.instance.get<GetFinanceServicesFinancetypesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
